
import React from 'react';
import { MdOutlineDelete, MdPersonOutline } from 'react-icons/md';
import './ResponsibleList.css'; // Reusing styles if possible, or add new ones

function ResponsibleList({ responsibles, onRemove, disabled }) {
	if (!responsibles || responsibles.length === 0) {
		return (
			<div className="responsibles-list-container">
				<p className="empty-text">Nenhum responsável selecionado.</p>
			</div>
		);
	}

	return (
		<div className="responsibles-list-container">
			{responsibles.map((resp, idx) => (
				<div className="item-row responsible-container" key={idx}>
					<span className='responsible-info-container'>
						<span style={{ opacity: 0.8, marginRight: -3, marginLeft: -6 }}>
							<MdPersonOutline size={28} />
						</span>
						<span className='responsible-texts'>
							<span>{resp.name}</span>
							<span style={{ opacity: 0.4 }}>{resp.email || resp.phone}</span>
						</span>
						{!disabled && (
							<button type="button" className="btn-delete-item" onClick={() => onRemove(idx)}>
								<MdOutlineDelete size={18} />
							</button>
						)}
					</span>
				</div>
			))}
		</div>
	);
}

export default ResponsibleList;
